import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './warningShipmentModalComponent.css';
import shipmentWarningModalImage from '../../../src/assets/images/shipment_warning_modal_image.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import SuccessModal from './SuccessfulModal';
import { fetchAllTrfLabAndTracer, verifyTrf } from '../../redux/trfUserSlice';
import { useDispatch } from 'react-redux';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

 
const VerifyTrfModalComponent = ({isOpen,onClose,trfDataById,userDetails,updateStateForVerifiedSuccess}) => {
    const dispatch = useDispatch();
  const handleClose = () => {
    // setOpen(false);
    onClose(false)
  };

  const handledVerifyTrf = () => {

    const body = {
      type: "verify",
      companyKeyId:trfDataById.companyKeyId, // Use state value
      testedBy:userDetails.email, // Use state value
    };
    const trfId = trfDataById.trfId;
    console.log("INSIDE VERIFY",trfId )
    console.log("INSIDE VERIFY body ",body )
    //  setIsDeleteModalOpen(true);
    dispatch(verifyTrf({trfId , body} )).then((response)=>{
      //  if(response.payload.success) {
        // onclose(true)
        handleClose()
        updateStateForVerifiedSuccess(true) 
      //  }  
      // onClose(false);
      const queryParams = {
        type: "all-trf",
        searchText: "",
        fromDate: "",
        toDate: "",
        pageSize:12, // Use state value
        pageNumber:1, // Use state value
        trfStatus: "",
      };
      dispatch(fetchAllTrfLabAndTracer(queryParams));
    });
    // .then(() => {
    //   dispatch(fetchAllTrfLabAndTracer(queryParams))})
  //onClose()
   // [dispatch, id];
   //window.location.reload()
    
  };
    return (
      
        <React.Fragment >
          {/* <Button variant="outlined" onClick={handleClickOpen}>
            Warning Shipment Modal
          </Button> */}
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            PaperProps={{
                style: {
                    maxWidth: '370px', // Adjust the maxWidth as needed
                    width: '100%',
                    maxHeight:'360px'
                },
            }}
            maxHeight="300" // Adjust the maxHeight as needed
            
          >
            <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
              {/* Modal title */}
                  <div className='warningShipmentModalImagediv'>  
                    <img 
                      className='warningShipmentModalImage'
                      src={shipmentWarningModalImage}
                    />
                    <h4 
                      className='headingForWarningShipmentModal'
                    > Warning </h4>
                    <h4 className='subHeadingForWwarningShipmentModal'>
                        Are you sure you want to verify {trfDataById.courierId}?
                    </h4>
                  </div>
                  <div>
                    <hr style={{width:"100%"}}>
                    </hr>
                  </div>
                  <div >
                    <Button className='noButton' onClick={handleClose}>No</Button>
                    <Button className='deleteButton' onClick={handledVerifyTrf}>Yes </Button>
                  </div>
            </DialogTitle>
            
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
                backgroundColor:"white",
                height: "7%",
                width: "6%",
              }}
            >
              <CloseIcon />
            </IconButton>
          </BootstrapDialog>
        </React.Fragment>
        
      );
}

export default VerifyTrfModalComponent